const authActionTypes = {
  // login
  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  // logout
  LOGOUT: "LOGOUT",
  INIT_CHANGE_STORE_PROCESS: "INIT_CHANGE_STORE_PROCESS",
  //
  SET_USER_TO_STORE: "SET_USER_TO_STORE",
};

export default authActionTypes;
